import React from 'react'
import { OfflineSync } from './offline-sync.component'
import { AutoSubmit } from './auto-submit.component'
import { ScrollToError } from './scroll-to-error.component'

export const Form = ({ id, submitTime, offlineTime, onAutoSubmit, loading, message, onClickContinue, onClickCancel, ...props }) => {
	return (
		<>
			{!loading && !!offlineTime && (
				<OfflineSync collection={id} syncTime={offlineTime} message={message} onClickContinue={onClickContinue} onClickCancel={onClickCancel} />
			)}
			{!loading && !!submitTime && <AutoSubmit submitTime={submitTime} onAutoSubmit={onAutoSubmit} />}
			<ScrollToError />
			<form id={id} {...props}></form>
		</>
	)
}

Form.defaultProps = {
	submitTime: 0,
	offlineTime: 600,
}
